import React from "react";
import { Button, buttonVariants } from "../../ui/button";
import { VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Typography } from "../typography/typography";
import { Loader2 } from "lucide-react"; // Import a spinner icon

interface IconButtonProps {
  variant?: VariantProps<typeof buttonVariants>["variant"];
  size?: VariantProps<typeof buttonVariants>["size"];
  icons?: React.ReactNode;
  label?: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const AppButton = ({
  variant = "default",
  size = "default",
  className,
  icons,
  label,
  onClick,
  disabled,
  isLoading = false,
}: IconButtonProps) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={cn(
        "bg-bg-brand-solid hover:bg-bg-brand-solid-hover flex h-9 cursor-pointer items-center justify-center rounded-full text-sm font-bold text-white hover:text-white sm:h-11",
        isLoading && "cursor-wait",
        className
      )}>
      {isLoading ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : icons}
      {label && (
        <Typography variant="p-sm" as="p" className="text-sm">
          {label}
        </Typography>
      )}
    </Button>
  );
};

export default AppButton;
